<template>
  <vg-view-field
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :value="value | enumText(constructionType)"
  />
</template>

<script>
import VgViewField from "@/components/Commons/VgViewField.vue";
import constructionType from "@/domain/construction-type";

export default {
  name: "ImageField",
  data() {
    return {
      constructionType
    }
  },
  components: {VgViewField},
  props: {
    label: String,
    value: String,
  }
}
</script>

<style scoped>

</style>